<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';

  export let horarios = [];
  
  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;

  const configPadrao = {
    campo_email: 'opcional',
    campo_cpf: 'oculto',
    campo_nascimento: 'obrigatorio',
    campo_endereco: 'oculto',
    campo_observacoes: 'oculto',
    label_observacoes: 'Observações'
  };

  let tenantConfig = null;
  let locaisConfigPorNome = {};
  let configPublica = { ...configPadrao };

  function montarConfigPublica(localNome = '') {
    const localConfig = localNome ? locaisConfigPorNome[localNome] : null;

    return {
      campo_email: (localConfig && localConfig.campo_email) || (tenantConfig && tenantConfig.campo_email) || configPadrao.campo_email,
      campo_cpf: (localConfig && localConfig.campo_cpf) || (tenantConfig && tenantConfig.campo_cpf) || configPadrao.campo_cpf,
      campo_nascimento: (localConfig && localConfig.campo_nascimento) || (tenantConfig && tenantConfig.campo_nascimento) || configPadrao.campo_nascimento,
      campo_endereco: (localConfig && localConfig.campo_endereco) || (tenantConfig && tenantConfig.campo_endereco) || configPadrao.campo_endereco,
      campo_observacoes: (localConfig && localConfig.campo_observacoes) || (tenantConfig && tenantConfig.campo_observacoes) || configPadrao.campo_observacoes,
      label_observacoes: (localConfig && localConfig.label_observacoes) || (tenantConfig && tenantConfig.label_observacoes) || configPadrao.label_observacoes
    };
  }

  onMount(async () => {
    if (!tenant || !tenant.slug) return;
    const urlConfig = Constantes.api_acesso.replace('acesso.php', 'obter_config_publica.php');
    const res = await conexao.conecta(urlConfig, { body: { slug: tenant.slug } });
    if (res && res.sucesso && res.tenant) {
      tenantConfig = res.tenant;
      locaisConfigPorNome = res.locais_config_por_nome || {};
      configPublica = montarConfigPublica();
    } else {
      tenantConfig = null;
      locaisConfigPorNome = {};
      configPublica = { ...configPadrao };
    }
  });

  // --- CONTROLE DE FILTROS ---
  let filtroLocal = '';
  let ordenacao = 'data_asc';
  let exibirPassados = false;
  let cpfCliente = '';
  let nascimentoCliente = ''; 
  let enderecoCliente = '';
  let idsSelecionados = new Set();

  $: locaisDisponiveis = [...new Set(horarios.map(h => h.local || 'Consultório'))].sort();

  // MÁGICA REATIVA: Filtra os horários cronologicamente, por local e aplica a ordenação
  $: horariosProcessados = horarios
    .filter(h => {
      // 1. Filtro de Passados
      if (!exibirPassados) {
        const dataHorario = new Date(h.inicio.replace(/-/g, '/')); 
        const agora = new Date();
        if (dataHorario < agora) return false;
      }
      
      // 2. Filtro de Local
      const localHorario = h.local || 'Consultório';
      if (filtroLocal && localHorario !== filtroLocal) return false;

      return true;
    })
    .sort((a, b) => {
      if (ordenacao === 'data_asc') return a.inicio.localeCompare(b.inicio);
      if (ordenacao === 'data_desc') return b.inicio.localeCompare(a.inicio);
      return 0;
    });

  // --- ESTADOS DO MODAL DE AGENDAMENTO MANUAL ---
  let modalAgendarVisivel = false;
  let horarioSelecionado = null;
  let nomeCliente = '';
  let emailCliente = '';
  let telefoneCliente = '';
  let observacoesCliente = '';
  let observacoesLabel = 'Observações';

  function formatarData(str) { 
    if(!str) return '';
    const [ano, mes, dia] = str.split(' ')[0].split('-'); 
    return `${dia}/${mes}/${ano}`; 
  }

  function alternarSelecao(id) {
    const novaSelecao = new Set(idsSelecionados);
    if (novaSelecao.has(id)) {
      novaSelecao.delete(id);
    } else {
      novaSelecao.add(id);
    }
    idsSelecionados = novaSelecao;
  }

  function selecionarTodosVisiveis() {
    const todosSelecionados = horariosProcessados.length > 0 && horariosProcessados.every(h => idsSelecionados.has(h.id));
    const novaSelecao = new Set(idsSelecionados);

    if (todosSelecionados) {
      horariosProcessados.forEach(h => novaSelecao.delete(h.id));
    } else {
      horariosProcessados.forEach(h => novaSelecao.add(h.id));
    }

    idsSelecionados = novaSelecao;
  }

  async function apagarHorario(id) {
    if (!confirm("Tem certeza que deseja remover este horário da sua agenda pública?")) return;
    dispatch('loading', true);
    const res = await conexao.conecta(Constantes.api_remover_horario, { body: { id_tenant: tenant.id, id: id } });
    dispatch('loading', false);
    idsSelecionados = new Set([...idsSelecionados].filter(item => item !== id));
    dispatch('recarregar', (res && res.mensagem) || 'Horário removido.');
  }

  async function apagarHorariosSelecionados() {
    const ids = [...idsSelecionados];
    if (ids.length === 0) return;

    if (!confirm(`Tem certeza que deseja remover ${ids.length} horário(s) selecionado(s) da sua agenda pública?`)) return;

    dispatch('loading', true);
    const res = await conexao.conecta(Constantes.api_remover_horario, { body: { id_tenant: tenant.id, ids } });
    dispatch('loading', false);
    idsSelecionados = new Set();
    dispatch('recarregar', (res && res.mensagem) || `${ids.length} horário(s) removido(s).`);
  }

  function abrirModalAgendar(horario) {
    horarioSelecionado = horario;
    configPublica = montarConfigPublica(horario.local);
    nomeCliente = '';
    emailCliente = '';
    telefoneCliente = '';
    cpfCliente = '';
    nascimentoCliente = '';
    enderecoCliente = '';
    observacoesCliente = '';
    // Label customizável: local -> tenant -> padrão
    observacoesLabel = configPublica.label_observacoes || 'Observações';
    modalAgendarVisivel = true;
  }

  function localConfigExists(localName) {
    return !!(localName && locaisConfigPorNome && locaisConfigPorNome[localName]);
  }

  function fecharModal() {
    modalAgendarVisivel = false;
    horarioSelecionado = null;
  }

  async function executarAgendamentoManual() {
    // 1. Validação dos campos imutáveis (sempre obrigatórios)
    if (!nomeCliente || !telefoneCliente) { 
      alert("O Nome e o Telefone/WhatsApp são obrigatórios."); 
      return; 
    }
    
    // 2. Validações dinâmicas (usa configPublica vinda da API, não do store)
    if (configPublica && configPublica.campo_email === 'obrigatorio' && !emailCliente) { alert("O E-mail do cliente é obrigatório pelas suas configurações."); return; }
    if (configPublica && configPublica.campo_cpf === 'obrigatorio' && !cpfCliente) { alert("O CPF do cliente é obrigatório."); return; }
    if (configPublica && configPublica.campo_nascimento === 'obrigatorio' && !nascimentoCliente) { alert("A Data de Nascimento é obrigatória."); return; }
    if (configPublica && configPublica.campo_endereco === 'obrigatorio' && !enderecoCliente) { alert("O Endereço do cliente é obrigatório."); return; }
    if (configPublica && configPublica.campo_observacoes === 'obrigatorio' && !observacoesCliente) { alert(`${observacoesLabel} é obrigatório.`); return; }

    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'agendar_manualmente.php');
    
    // 3. Envio de todos os dados para a API
    const res = await conexao.conecta(url, {
      body: {
        id_tenant: tenant.id,
        id_horario: horarioSelecionado.id,
        nome_cliente: nomeCliente,
        telefone: telefoneCliente,
        email: emailCliente,
        cpf: cpfCliente,
        nascimento: nascimentoCliente,
        endereco_paciente: enderecoCliente, // Enviamos como endereco_paciente para não confundir com o endereço da clínica
        observacoes: observacoesCliente
      }
    });
    
    dispatch('loading', false);
    
    if (res && res.sucesso) {
      fecharModal();
      dispatch('recarregar', (res && res.mensagem) || 'Agendado com sucesso!');
    } else {
      alert((res && res.mensagem) || 'Erro ao agendar manualmente.');
    }
  }
</script>

<section class="card-panel fade-in">
  <div class="header-flex">
    <h2>Meus Horários Oferecidos</h2>
  </div>
  <p class="text-muted mb-4">Gerencie os horários que estão visíveis no seu link público ou reserve-os diretamente.</p>

  <div class="filter-bar fade-in mb-3">
    <div class="filter-group">
      <select class="input-app" bind:value={filtroLocal}>
        <option value="">Todos os locais</option>
        {#each locaisDisponiveis as loc}
          <option value={loc}>{loc}</option>
        {/each}
      </select>
    </div>

    <div class="filter-group">
      <select class="input-app" bind:value={ordenacao}>
        <option value="data_asc">Mais Próximos</option>
        <option value="data_desc">Mais Distantes</option>
      </select>
    </div>

    <div class="filter-group switch-container">
      <label class="switch">
        <input type="checkbox" bind:checked={exibirPassados}>
        <span class="slider"></span>
      </label>
      <span class="switch-label">Exibir horários passados</span>
    </div>
  </div>

  <div class="bulk-actions-bar fade-in mb-3">
    <div>
      <strong>{idsSelecionados.size}</strong> horário(s) selecionado(s)
    </div>
    <div class="bulk-actions-row">
      <button class="btn-table-action btn-select-all" on:click={selecionarTodosVisiveis}>
        {horariosProcessados.length > 0 && horariosProcessados.every(h => idsSelecionados.has(h.id)) ? 'Desmarcar todos' : 'Selecionar todos'}
      </button>
      <button class="btn-table-action btn-delete" on:click={apagarHorariosSelecionados} disabled={idsSelecionados.size === 0}>
        <i class="far fa-trash-alt"></i> Excluir selecionados
      </button>
    </div>
  </div>

  <div class="table-scroll">
    {#if horariosProcessados.length === 0}
      <div class="empty text-muted text-center" style="padding: 30px 0;">Nenhum horário aberto encontrado com os filtros atuais.</div>
    {:else}
      <table class="app-table">
        <thead>
          <tr>
            <th class="selection-cell">
              <input
                type="checkbox"
                aria-label="Selecionar todos os horários visíveis"
                checked={horariosProcessados.length > 0 && horariosProcessados.every(h => idsSelecionados.has(h.id))}
                on:change={selecionarTodosVisiveis}
              />
            </th>
            <th>Data e Hora</th>
            <th>Local / Modalidade</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {#each horariosProcessados as h}
            <tr class={new Date(h.inicio.replace(/-/g, '/')) < new Date() ? 'row-past' : ''}>
              <td class="selection-cell">
                <input
                  type="checkbox"
                  aria-label={`Selecionar horário ${formatarData(h.inicio)} às ${h.inicio.split(' ')[1].substring(0,5)}`}
                  checked={idsSelecionados.has(h.id)}
                  on:change={() => alternarSelecao(h.id)}
                />
              </td>
              <td class="fw-bold">
                <i class="far fa-clock text-muted me-2"></i> 
                {formatarData(h.inicio)} às {h.inicio.split(' ')[1].substring(0,5)}
              </td>
              <td>
                <span class="badge-type">{h.local || 'Consultório'}</span>
                {#if h.endereco}<small class="text-muted block-dir">{h.endereco}</small>{/if}
              </td>
              <td class="action-buttons-cell">
                <button class="btn-table-action btn-book" on:click={() => abrirModalAgendar(h)} title="Agendar Cliente Manualmente">
                  <i class="fas fa-user-plus"></i> Agendar
                </button>
                <button class="btn-table-action btn-delete" on:click={() => apagarHorario(h.id)} title="Excluir Horário da Agenda Pública">
                  <i class="far fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}
  </div>
</section>

{#if modalAgendarVisivel}
  <div class="modal-overlay fade-in" on:mousedown={fecharModal}>
    <div class="modal-card" on:mousedown|stopPropagation>
      <button class="close-btn" on:click={fecharModal}><i class="fas fa-times"></i></button>
      <h3>Agendamento Manual</h3>
      <p class="text-muted mt-1">Preencha os dados para reservar o horário de <strong>{formatarData(horarioSelecionado.inicio)} às {horarioSelecionado.inicio.split(' ')[1].substring(0,5)}</strong></p>
      
      <div class="form-manual-grid mt-4">
        <div class="field-item">
          <label for="m_nome">Nome do Cliente *</label>
          <input type="text" id="m_nome" class="input-app" bind:value={nomeCliente} placeholder="Nome completo" required />
        </div>
        
        <div class="field-item">
          <label for="m_tel">Telefone / WhatsApp *</label>
          <input type="text" id="m_tel" class="input-app" bind:value={telefoneCliente} placeholder="(00) 00000-0000" required />
        </div>

        {#if configPublica?.campo_email !== 'oculto'}
          <div class="field-item">
            <label for="m_email">E-mail {configPublica?.campo_email === 'obrigatorio' ? '*' : ''}</label>
            <input type="email" id="m_email" class="input-app" bind:value={emailCliente} placeholder="cliente@email.com" required={configPublica?.campo_email === 'obrigatorio'} />
          </div>
        {/if}

        {#if configPublica?.campo_cpf !== 'oculto'}
          <div class="field-item">
            <label for="m_cpf">CPF {configPublica?.campo_cpf === 'obrigatorio' ? '*' : ''}</label>
            <input type="text" id="m_cpf" class="input-app" bind:value={cpfCliente} placeholder="000.000.000-00" required={configPublica?.campo_cpf === 'obrigatorio'} />
          </div>
        {/if}

        {#if configPublica?.campo_nascimento !== 'oculto'}
          <div class="field-item">
            <label for="m_nasc">Data de Nascimento {configPublica?.campo_nascimento === 'obrigatorio' ? '*' : ''}</label>
            <input type="date" id="m_nasc" class="input-app" bind:value={nascimentoCliente} required={configPublica?.campo_nascimento === 'obrigatorio'} />
          </div>
        {/if}

        {#if configPublica?.campo_endereco !== 'oculto'}
          <div class="field-item">
            <label for="m_end">Endereço {configPublica?.campo_endereco === 'obrigatorio' ? '*' : ''}</label>
            <input type="text" id="m_end" class="input-app" bind:value={enderecoCliente} placeholder="Rua, número, bairro..." required={configPublica?.campo_endereco === 'obrigatorio'} />
          </div>
        {/if}

        {#if configPublica?.campo_observacoes !== 'oculto'}
          <div class="field-item">
            <label for="m_obs">{observacoesLabel}{configPublica?.campo_observacoes === 'obrigatorio' ? ' *' : ''}</label>
            <textarea id="m_obs" class="input-app" rows="3" bind:value={observacoesCliente} placeholder={observacoesLabel} required={configPublica?.campo_observacoes === 'obrigatorio'}></textarea>
          </div>
        {/if}
      </div>

      <div class="modal-buttons mt-4">
        <button class="btn-primary w-100" on:click={executarAgendamentoManual}>
          <i class="fas fa-check-circle me-2"></i> Criar Agendamento
        </button>
        <button class="btn-link-modal mt-2" on:click={fecharModal}>Cancelar</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; }
  
  /* Estilos da Barra de Filtros */
  .filter-bar { display: flex; gap: 15px; background: #f8faf9; padding: 15px; border-radius: 12px; border: 1px solid var(--border); flex-wrap: wrap; align-items: center; }
  .filter-group { flex: 1; min-width: 150px; position: relative; }
  
  /* Estilos do Interruptor (Switch) integrado nos filtros */
  .switch-container { flex: unset; min-width: max-content; display: flex; align-items: center; gap: 10px; background: white; padding: 10px 15px; border-radius: 8px; border: 1px solid var(--border); box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
  .switch { position: relative; display: inline-block; width: 36px; height: 18px; flex-shrink: 0; margin-bottom: 0; }
  .switch input { opacity: 0; width: 0; height: 0; }
  .slider { position: absolute; cursor: pointer; inset: 0; background-color: #cbd5e0; transition: .3s; border-radius: 20px; }
  .slider:before { position: absolute; content: ""; height: 12px; width: 12px; left: 3px; bottom: 3px; background-color: white; transition: .3s; border-radius: 50%; }
  input:checked + .slider { background-color: var(--primary); }
  input:checked + .slider:before { transform: translateX(18px); }
  .switch-label { font-size: 0.85rem; font-weight: 700; color: var(--text-main); }

  .block-dir { display: block; font-size: 0.75rem; margin-top: 2px; }
  .row-past { background-color: #fafafa; opacity: 0.65; }

  .bulk-actions-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    background: #f8faf9;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px 15px;
  }
  .bulk-actions-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .selection-cell { width: 42px; text-align: center; }
  .selection-cell input { cursor: pointer; }

  /* Célula de Ações */
  .action-buttons-cell { display: flex; gap: 10px; justify-content: center; }
  .btn-table-action { border: none; padding: 6px 12px; border-radius: 6px; font-weight: 700; font-size: 0.8rem; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: 0.2s; }
  .btn-book { background-color: #ebf8ff; color: #2b6cb0; }
  .btn-book:hover { background-color: #2b6cb0; color: white; }
  .btn-select-all { background-color: #edf2f7; color: #2d3748; }
  .btn-select-all:hover { background-color: #e2e8f0; }
  .btn-delete { background-color: #fff5f5; color: #c53030; padding: 6px 10px; }
  .btn-delete:hover { background-color: #c53030; color: white; }
  .btn-delete:disabled { opacity: 0.5; cursor: not-allowed; }
  .text-center { text-align: center; }

  /* CSS do Modal Flutuante */
 /* CSS do Modal Flutuante */
  .modal-overlay { 
    position: fixed; 
    inset: 0; 
    background: rgba(0, 0, 0, 0.5); 
    backdrop-filter: blur(4px); 
    z-index: 9999; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    padding: 15px; /* Evita que o modal cole nas bordas do ecrã no telemóvel */
  }
  
  .modal-card { 
    background: white; 
    padding: 30px; 
    border-radius: 16px; 
    width: 100%; 
    max-width: 440px; 
    position: relative; 
    box-shadow: 0 10px 40px rgba(0,0,0,0.2); 
    text-align: center; 
    max-height: 90vh; /* Impede que o modal fique maior que 90% da altura da tela */
    overflow-y: auto; /* Cria a barra de rolagem internamente! */
  }

  /* Embelezar a barra de rolagem para ficar com aspeto moderno */
  .modal-card::-webkit-scrollbar { width: 6px; }
  .modal-card::-webkit-scrollbar-track { background: transparent; }
  .modal-card::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
  .modal-card::-webkit-scrollbar-thumb:hover { background: #a0aec0; }.close-btn { position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 1.2rem; color: #999; cursor: pointer; }
  
  .form-manual-grid { display: flex; flex-direction: column; gap: 15px; text-align: left; }
  .field-item { display: flex; flex-direction: column; gap: 5px; }
  .field-item label { font-size: 0.8rem; font-weight: 700; color: var(--text-main); }
  
  .w-100 { width: 100%; }
  .btn-primary { background: var(--primary); color: white; border: none; padding: 14px; border-radius: 8px; font-weight: 700; cursor: pointer; transition: 0.2s; }
  .btn-primary:hover { background: var(--primary-dark); }
  .btn-link-modal { background: none; border: none; color: #718096; text-decoration: underline; cursor: pointer; font-size: 0.85rem; font-weight: 600; }

  @media (max-width: 768px) {
    .filter-bar { flex-direction: column; }
    .filter-group { width: 100%; }
    .switch-container { width: 100%; justify-content: center; }
    .bulk-actions-bar { align-items: flex-start; }
    .bulk-actions-row { width: 100%; }
  }

  @media (max-width: 640px) {
    .modal-card { padding: 20px 16px; }
    .action-buttons-cell { flex-direction: column; }
    .btn-table-action { justify-content: center; }
    .selection-cell { width: 34px; }
  }
</style>